import actions from "./actions";

const initState = {
    loading: false,
    buttonLoading: false,
    dailyAddonPriceMappingError: null,
    dailyAddonPriceMappingSuccess: null,
    dailyAddonPriceMappingData: [],

    openDailyAddonModal: false,

    updateDailyAddonWiseMappingLoading: false,
    updateDailyAddonWiseMappingError: null,
    updateDailyAddonWiseMappingMessage: null,

};

export default function reducer(state = initState, action) {

    switch (action.type) {

        case actions.OPEN_UPDATE_DAILY_ADDON_MODAL:
            return {
                ...state,
                openDailyAddonModal: true,
            };

        case actions.CLOSE_UPDATE_DAILY_ADDON_MODAL:
            return {
                ...state,
                openDailyAddonModal: false,
            };

        case actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_BY_DEALERID:
            return {
                ...state,
                updateDailyAddonWiseMappingLoading: true,
                updateDailyAddonWiseMappingError: null,
                updateDailyAddonWiseMappingMessage: null,
            };
        case actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_BY_DEALERID_SUCCESS:
            return {
                ...state,
                updateDailyAddonWiseMappingLoading: false,
                updateDailyAddonWiseMappingError: null,
                updateDailyAddonWiseMappingMessage: action.payload.message,
                openDailyAddonModal: false,
            };
        case actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_BY_DEALERID_FAILED:
            return {
                ...state,
                updateDailyAddonWiseMappingLoading: false,
                updateDailyAddonWiseMappingError: action.payload.error,
                updateDailyAddonWiseMappingMessage: null,
                openDailyAddonModal: false,
            };



        case actions.GET_ALL_DAILY_ADDON_PRICE_MAPPING_DATA:
            return {
                ...state,
                loading: true,
                dailyAddonPriceMappingError: null,
                dailyAddonPriceMappingSuccess: null,
            };

        case actions.GET_ALL_DAILY_ADDON_PRICE_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                dailyAddonPriceMappingError: null,
                dailyAddonPriceMappingSuccess: null,
                dailyAddonPriceMappingData: action.payload.data,
            };

        case actions.GET_ALL_DAILY_ADDON_PRICE_MAPPING_DATA_FAILED:
            return {
                ...state,
                loading: false,
                dailyAddonPriceMappingError: action.payload.error,
                dailyAddonPriceMappingSuccess: null,
            };
        case actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA:
            return {
                ...state,
                loading: true,
                buttonLoading: true,
                dailyAddonPriceMappingError: null,
                dailyAddonPriceMappingSuccess: null,
            };

        case actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                dailyAddonPriceMappingError: null,
                dailyAddonPriceMappingSuccess: action.message,
                dailyAddonPriceMappingData: action.data,
            };

        case actions.UPDATE_DAILY_ADDON_PRICE_MAPPING_DATA_FAILED:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                dailyAddonPriceMappingError: action.serror,
                dailyAddonPriceMappingSuccess: null,
            };
        case actions.RESET_DAILY_ADDON_PRICE_MAPPING_MESSAGES:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                dailyAddonPriceMappingError: null,
                dailyAddonPriceMappingSuccess: null,
                updateDailyAddonWiseMappingError: null,
                updateDailyAddonWiseMappingMessage: null,
            };
        default:
            return state;
    }
}